import React, { useState } from 'react';
import PropTypes from 'prop-types';
//Styles
import { useStyles } from 'components/dialogs/account/DialogAccount.style';
import {
    Icon,
    Tab,
    Tabs,
    Tooltip
} from '@mui/material';
//Pcp Components
import TrendIcon from 'assets/svg/TrendIcon';
import PricingEngineIcon from 'assets/svg/PricingEngineIcon';
import marketplaceIcon from 'assets/svg/marketplaceIcon';
import ManageSpeSheet from 'components/sheets/AccountManageModuleSheets/ManageSpeSheet';
import ManagePeSheet from 'components/sheets/AccountManageModuleSheets/ManagePeSheet';
import ManagePerfSheet from 'components/sheets/AccountManageModuleSheets/ManagePerfSheet';
import ManageSliderSheet from 'components/sheets/AccountManageModuleSheets/ManageSliderSheet';
import ManageAdboxSheet from 'components/sheets/AccountManageModuleSheets/ManageAdboxSheet';
import ManageDmSheet from 'components/sheets/AccountManageModuleSheets/ManageDmSheet';
import DefaultModuleManageSheet from 'components/sheets/AccountManageModuleSheets/DefaultModuleManageSheet';

const DialogManageAccountModules = ({
    accountModules,
    setAccountModule,
    setSpeConfig,
    sites,
    speConfig,
    setPerfConfig,
    perfConfig,
    setSliderConfig,
    sliderConfig,
    setAdboxConfig,
    adboxConfig,
    dmConfig,
    setDmConfig
}) => {
    const classes = useStyles();

    const [tab, setTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTab(newValue);
    };

    const renderTab = () => {
        switch (tab) {
        case 0:
            return <ManageSpeSheet
                activeModule={accountModules.spe}
                setActiveModule={(value) => setAccountModule('spe',value)}
                sites={sites}
                config={speConfig}
                setConfig={setSpeConfig}
            />;
        case 1:
            return <ManagePeSheet
                activeModule={accountModules.pe}
                setActiveModule={(value) => setAccountModule('pe',value)}
            />;
        case 2:
            return <DefaultModuleManageSheet
                activeModule={accountModules.trends}
                setActiveModule={(value) => setAccountModule('trends',value)}
                moduleName={'TRENDS'}
            />;
        case 3:
            return <ManagePerfSheet
                activeModule={accountModules.perf}
                setActiveModule={(value) => setAccountModule('perf',value)}
                sites={sites}
                config={perfConfig}
                setConfig={setPerfConfig}
            />;
        case 4:
            return <ManageSliderSheet
                activeModule={accountModules.slider}
                setActiveModule={(value) => setAccountModule('slider',value)}
                config={sliderConfig}
                setConfig={setSliderConfig}
                sites={sites}
            />;
        case 5:
            return <ManageAdboxSheet
                activeModule={accountModules.adbox}
                setActiveModule={(value) => setAccountModule('adbox',value)}
                config={adboxConfig}
                setConfig={setAdboxConfig}
                sites={sites}
            />;
        case 6:
            return <ManageDmSheet
                activeModule={accountModules.dm}
                setActiveModule={(value) => setAccountModule('dm',value)}
                config={dmConfig}
                setConfig={setDmConfig}
            />;
        case 7:
            return <DefaultModuleManageSheet
                activeModule={accountModules.mp}
                setActiveModule={(value) => setAccountModule('mp',value)}
                moduleName={'Market Place'}
            />;
        case 8:
            return <DefaultModuleManageSheet
                activeModule={accountModules.catalog}
                setActiveModule={(value) => setAccountModule('catalog',value)}
                moduleName={'Catalogues'}
            />;
        }
    };

    return <div className={classes.moduleStepContainer}>
        <Tabs
            orientation='vertical'
            variant='scrollable'
            value={tab}
            onChange={handleTabChange}
        >
            <Tooltip title={'SPE'} placement='right' disableInteractive>
                <Tab
                    icon={<Icon color='primary'>euro_symbol</Icon>}
                    aria-label='spe'
                    style={{ borderRadius: '3px', margin: '2px', marginRight: '5px', backgroundColor: accountModules?.spe ? '#1890A53d':'white' }}
                />
            </Tooltip>
            <Tooltip title={'Pricing Engine'} placement='right' disableInteractive>
                <Tab
                    icon={PricingEngineIcon(25,25,'#1890A5')}
                    aria-label='pe'
                    style={{ borderRadius: '3px', margin: '2px', marginRight: '5px', backgroundColor: accountModules?.pe ? '#1890A53d':'white' }}
                />
            </Tooltip>
            <Tooltip title={'Trends'} placement='right' disableInteractive>
                <Tab
                    icon={TrendIcon(25,25,'#1890A5')}
                    aria-label='trends'
                    style={{ borderRadius: '3px', margin: '2px', marginRight: '5px', backgroundColor: accountModules?.trends ? '#1890A53d':'white' }}
                />
            </Tooltip>
            <Tooltip title={'Perf'} placement='right' disableInteractive>
                <Tab
                    icon={<Icon color='primary'>trending_up</Icon>}
                    aria-label='perf'
                    style={{ borderRadius: '3px', margin: '2px', marginRight: '5px', backgroundColor: accountModules?.perf ? '#1890A53d':'white' }}
                />
            </Tooltip>
            <Tooltip title={'Slider'} placement='right' disableInteractive>
                <Tab
                    icon={<Icon color='primary'>calendar_view_day</Icon>}
                    aria-label='slider'
                    style={{ borderRadius: '3px', margin: '2px', marginRight: '5px', backgroundColor: accountModules?.slider ? '#1890A53d':'white' }}
                />
            </Tooltip>
            <Tooltip title={'Adbox'} placement='right' disableInteractive>
                <Tab
                    icon={<Icon color='primary'>mail</Icon>}
                    aria-label='adbox'
                    style={{ borderRadius: '3px', margin: '2px', marginRight: '5px', backgroundColor: accountModules?.adbox ? '#1890A53d':'white' }}
                />
            </Tooltip>
            <Tooltip title={'Daily Monitoring'} placement='right' disableInteractive>
                <Tab
                    icon={<Icon color='primary'>drafts</Icon>}
                    aria-label='dm'
                    style={{ borderRadius: '3px', margin: '2px', marginRight: '5px', backgroundColor: accountModules?.dm ? '#1890A53d':'white' }}
                />
            </Tooltip>
            <Tooltip title={'Market Place'} placement='right' disableInteractive>
                <Tab
                    icon={marketplaceIcon(25,25,'#1890A5')}
                    aria-label='mp'
                    style={{ borderRadius: '3px', margin: '2px', marginRight: '5px', backgroundColor: accountModules?.mp ? '#1890A53d':'white' }}
                />
            </Tooltip>
            <Tooltip title={'Catalog'} placement='right' disableInteractive>
                <Tab
                    icon={<Icon color='primary'>menu_book</Icon>}
                    aria-label='catalog'
                    style={{ borderRadius: '3px', margin: '2px', marginRight: '5px', backgroundColor: accountModules?.catalog ? '#1890A53d':'white' }}
                />
            </Tooltip>
        </Tabs>
        {renderTab()}
    </div>;
};

DialogManageAccountModules.propTypes = {
    accountModules: PropTypes.object,
    setAccountModule: PropTypes.func,
    setSpeConfig: PropTypes.func,
    sites: PropTypes.array,
    speConfig: PropTypes.object,
    setPerfConfig: PropTypes.func,
    perfConfig: PropTypes.object,
    setSliderConfig: PropTypes.func,
    sliderConfig: PropTypes.object,
    setAdboxConfig: PropTypes.func,
    adboxConfig: PropTypes.object,
    dmConfig: PropTypes.object,
    setDmConfig: PropTypes.func,
};

export default DialogManageAccountModules;
